module.exports = __webpack_public_path__ + "static/media/rightArrow.9f388220.svg";